import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { from, Observable, switchMap } from 'rxjs';
import { environment } from '../environments/environment';
import { UserService } from './user.service';
import { SignatureServiceService } from './signature-service.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private apiUrl = environment.scopingApiUrl;

  private token: string;
  constructor(private http: HttpClient, private userService: UserService, private signatureService: SignatureServiceService) {
    this.token = this.userService.getAccessToken();
  }

  validateUser(username: string, password: string): Observable<HttpResponse<any>> {
    const body = {
      username: username,
      password: password
    };
    return from(this.signatureService.generateHMACSignature(body)).pipe(
      switchMap(signature => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${this.token}`,
          'X-HMAC-Signature': signature
        });

        const url = `${this.apiUrl}/api/Auth/ValidateUser`;
        return this.http.post(url, body, { headers: headers, observe: 'response' });
      }));
  }

  validateUserRedirection(UserId: string, LoginType: number): Observable<HttpResponse<any>> {
    const body = {
      UserId: UserId,
      LoginType: LoginType
    };
    return from(this.signatureService.generateHMACSignature(body)).pipe(
      switchMap(signature => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${this.token}`,
          'X-HMAC-Signature': signature
        });
        const url = `${this.apiUrl}/api/Auth/validateUserRedirection`;
        return this.http.post(url, body, { headers: headers, observe: 'response' });
      }));
  }
  validateUserRedirectionNew(Token: string, LoginType: number): Observable<HttpResponse<any>> {
    const body = {
      Token: Token,
      LoginType: LoginType
    };
    return from(this.signatureService.generateHMACSignature(body)).pipe(
      switchMap(signature => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${this.token}`,
          'X-HMAC-Signature': signature
        });
        const url = `${this.apiUrl}/api/Auth/validateUserRedirectionNew`;
        return this.http.post(url, body, { headers: headers, observe: 'response' });
      }));
  }

  GetServiceProviderID(avacom_CustomerID: number): Observable<HttpResponse<any>> {
    const hmacPayload = { avacom_CustomerID: avacom_CustomerID };
    return from(this.signatureService.generateHMACSignature(hmacPayload)).pipe(
      switchMap(signature => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${this.token}`,
          'X-HMAC-Signature': signature
        });
        const url = `${this.apiUrl}/api/User/GetServiceProviderID?avacom_CustomerID=${avacom_CustomerID}`;
        return this.http.get(url, { headers: headers, observe: 'response' });
      }));
  }
  ChangePassword(UserId: number, Password: string, Oldpassword: string): Observable<HttpResponse<any>> {
    const hmacPayload = { UserId: UserId, Password: Password, Oldpassword: Oldpassword };
    return from(this.signatureService.generateHMACSignature(hmacPayload)).pipe(
      switchMap(signature => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${this.userService.getAccessToken()}`,
          'X-HMAC-Signature': signature
        });
        const url = `${environment.apiUrl}/api/User/ChangePassword?UserId=${UserId}&Password=${encodeURIComponent(Password)}&Oldpassword=${encodeURIComponent(Oldpassword)}`;
        return this.http.post(url, {}, { headers: headers, observe: 'response' });
      }));
  }

  CaptureClientPortalPageWiseDetails(payload: any): Observable<HttpResponse<any>> {
    return from(this.signatureService.generateHMACSignature(payload)).pipe(
      switchMap(signature => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${this.userService.getAccessToken()}`,
          'X-HMAC-Signature': signature
        });
        const url = `${this.apiUrl}/api/ClientPortal/CaptureClientPortalPageWiseDetails`;
        return this.http.post(url, payload, { headers: headers, observe: 'response' });
      }));
  }
  CaptureClientPortalLoginDetail(payload: any): Observable<HttpResponse<any>> {
    return from(this.signatureService.generateHMACSignature(payload)).pipe(
      switchMap(signature => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${this.userService.getAccessToken()}`,
          'X-HMAC-Signature': signature
        });
        const url = `${this.apiUrl}/api/ClientPortal/CaptureClientPortalLoginDetail`;
        return this.http.post(url, payload, { headers: headers, observe: 'response' });
      }));
  }
}
